import React, { createContext, useCallback, useState } from 'react';

import { Flow } from '../services/viva/constants';
import { initialCheckoutState } from '../store/slices';

import type { CartSelectionsByDate } from '../components/BuyTickets';
import type { CheckoutType } from '../store/types';

type Props = {
  children: React.ReactNode;
};

type InitializeProps = {
  checkout: CheckoutType;
  flow: Flow;
  isCityPassRedemption?: boolean;
  cartSelectionsByDate: CartSelectionsByDate;
};

type ConfirmationPageContextType = {
  initialize: ({
    checkout,
    flow,
    isCityPassRedemption,
  }: InitializeProps) => void;
} & InitializeProps;

export const ConfirmationPageContext =
  createContext<ConfirmationPageContextType>({
    cartSelectionsByDate: [] as CartSelectionsByDate,
    checkout: initialCheckoutState,
    flow: Flow.CHECKOUT,
    initialize: () => {
      console.log('NO OP');
      /* no op */
    },
  });

export const ConfirmationPageProvider = ({ children }: Props) => {
  const [checkout, setCheckout] = useState<CheckoutType>(initialCheckoutState);
  const [cartSelectionsByDate, setCartSelectionsByDate] =
    useState<CartSelectionsByDate>([] as CartSelectionsByDate);
  const [flow, setFlow] = useState<Flow>(Flow.CHECKOUT);
  const [isCityPassRedemption, setIsCityPassRedemption] =
    useState<boolean>(false);

  const initializeCallback = useCallback(
    ({
      checkout: _checkout,
      cartSelectionsByDate,
      flow,
      isCityPassRedemption: _isCityPassRedemption = false,
    }: InitializeProps) => {
      setCartSelectionsByDate(cartSelectionsByDate);
      setCheckout(_checkout);
      setFlow(flow);
      setIsCityPassRedemption(_isCityPassRedemption);
    },
    [setCheckout, setFlow, setIsCityPassRedemption],
  );

  return (
    <ConfirmationPageContext.Provider
      value={{
        cartSelectionsByDate,
        checkout,
        flow,
        initialize: initializeCallback,
        isCityPassRedemption,
      }}
    >
      {children}
    </ConfirmationPageContext.Provider>
  );
};
